/* eslint-disable react/prop-types */
import React, { useState } from "react";
import { Table } from "antd";

const Datatable = ({ columns, dataSource, onRowSelect, ...tableProps }) => {
  const [selectedRowKeys, setSelectedRowKeys] = useState([]);

  const onSelectChange = (newSelectedRowKeys) => {
    setSelectedRowKeys(newSelectedRowKeys);
    if (onRowSelect) {
      onRowSelect(newSelectedRowKeys);
    }
  };

  const rowSelection = {
    selectedRowKeys,
    onChange: onSelectChange,
  };

  return (
    <Table
      className="table datanew dataTable no-footer"
      rowSelection={rowSelection}
      columns={columns || []}
      dataSource={dataSource || []}
      rowKey={(record) => record.id || Math.random().toString()}
      {...tableProps}
    />
  );
};

export default Datatable;
